import { VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { vw } from '../../styles/theme'
import NavSPLink from './NavSPLink'

export type NavSPNavProps = BoxProps & {
  handleClick: () => void
}

const NavSPNav: React.FC<NavSPNavProps> = ({ handleClick, ...others }) => {
  return (
    <>
      <Box {...others}>
        <VStack spacing={vw(64)}>
          <NavSPLink to="/" localizeKey="nav__global__top" onClick={handleClick} />
          <NavSPLink to="/artists/" localizeKey="nav__global__artists" onClick={handleClick} />
          <NavSPLink to="/event/" localizeKey="nav__global__event" onClick={handleClick} />
          <NavSPLink to="/ticket/" localizeKey="nav__global__ticket" onClick={handleClick} />
          <NavSPLink to="/about/" localizeKey="nav__global__about" onClick={handleClick} />
          <NavSPLink to="/access/" localizeKey="nav__global__access" onClick={handleClick} />
        </VStack>
      </Box>
    </>
  )
}

export default NavSPNav
